import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AssetSubscriptionV26 } from 'src/app/models-v26/asset-subscription-v26';
import { DeliveryItemV26 } from 'src/app/models-v26/deliveryitem-v26';
import { ActionResponse } from 'src/app/models/action-response';
import { Desk } from 'src/app/models/desk';
import { CopyAssetDueDatesV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/copy-asset-wizard/activation-step/copy-asset-due-date-info';
import { CopyAssetAdditionalInfoV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/copy-asset-wizard/additional-step/additional-info';
import { CopyAssetInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/copy-asset-wizard/init-step/init-step';
import * as fromOrderWizardV26 from './reducer';
import { State } from './state';

export const selectCopyAssetWizardState = createFeatureSelector<State>(fromOrderWizardV26.copyAssetWizardFeatureKey);

export const selectInitStep = createSelector(selectCopyAssetWizardState, (state: State): CopyAssetInitStepV26 => state.initStep);

export const selectAssetServicesInitStep = createSelector(
  selectCopyAssetWizardState,
  (state: State): AssetSubscriptionV26[] => state.initAssetServiceStep,
);

export const selectDeskStep = createSelector(selectCopyAssetWizardState, (state: State): Desk => state.deskStep);

export const selectDueDateStep = createSelector(selectCopyAssetWizardState, (state: State): CopyAssetDueDatesV26 => state.dueDatesStep);

export const selectServiceStep = createSelector(selectCopyAssetWizardState, (state: State): DeliveryItemV26[] => state.serviceStep);

export const selectAdditionaInfoStep = createSelector(
  selectCopyAssetWizardState,
  (state: State): CopyAssetAdditionalInfoV26 => state.addInfoStep,
);

export const selectNewOrderState = createSelector(selectCopyAssetWizardState, (state: State): ActionResponse => state.newOrderResponse);

export const selectErrorMessage = createSelector(selectCopyAssetWizardState, (state: State): string => state.errorMessage);
